import { useState } from 'react'
import Lightbox from '@/components/Lightbox'
import PhotoSliderCard from '@/components/PhotoSliderCard'
import { PROJECTS } from '@/data/content'

export default function ProjectGallery() {
  const [open, setOpen] = useState<{ project: number; index: number } | null>(null)
  const active = open ? PROJECTS[open.project] : null

  return (
    <>
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-5">
        {PROJECTS.map((project, projectIndex) => (
          <PhotoSliderCard
            key={project.title}
            photos={project.photos}
            title={project.title}
            priority={projectIndex < 2}
            onExpand={index => setOpen({ project: projectIndex, index })}
          />
        ))}
      </div>

      {open && active && (
        <Lightbox
          photos={active.photos}
          index={open.index}
          title={active.title}
          onIndex={next => setOpen({ project: open.project, index: next })}
          onClose={() => setOpen(null)}
        />
      )}
    </>
  )
}
